<template>
  <div id="vi">

                   
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999"> 培育钻石  
<span v-if="hl" style="margin-left:30px;color:#666"> 培育钻汇率 {{hl}} </span> 
<span style="margin-left:10px;color:red">{{tips}}</span>
</li>

</ul>

</div>
</div>



<div v-if="loading" style="position:fixed;top:50%;left:45%"><img src="../assets/loading.gif"></div>
<div style="margin:0 auto" class="widu">

<div class="form-group" style="height:30px">
    <div class="col-sm-3" style="padding:0;margin:0;">
      <input type="text" class="form-control" name="zsh"  placeholder="证书号 多个用空格隔开"  v-model="zsh" >
    </div>
     <div class="col-sm-3">
      <input type="text" class="form-control" name="hao"  placeholder="产品编号 可复制excel多行批量搜索"  v-model="hao" >
    </div>
    <div class="col-sm-1">
    <button type="button" class="btn btn-default" v-on:click="search()" style="margin:0;">搜索</button>
    </div>
    <div class="col-sm-1">
    <button type="button" class="btn btn-default" v-on:click="reset()" style="margin:0;">重置</button>
    </div>
    <div class="col-sm-3">
    </div>
</div>
<table border='1' style='border-collapse:collapse; table-layout: fixed;margin:0 auto' class="widu" cellspacing='0'>
<tr style="background:#FFF;border-bottom:1px solod #000;font-size:12px" >
<td>证书类型</td><td width="6%">产品编号</td><td width="6%">证书号</td>

<td width="5%">
  <select id="xz" style="color:blue;border:0" v-model="selected_xz" v-on:click="getData('xz',selected_xz)">
    <option value="">形状</option>
    <option value="圆形">圆形</option>
    <option value="公主方">公主方</option>
    <option value="椭圆形">椭圆形</option>
    <option value="梨形">梨形</option>
    <option value="祖母绿">祖母绿</option>
    <option value="心形">心形</option>
    <option value="马眼形">马眼形</option>
    <option value="雷迪恩">雷迪恩</option>
    <option value="垫形">垫形</option>
    <option value="三角形">三角形</option>
  </select>
</td>

<td width="6%">
  <select id="zl" style="color:blue;border:0" v-model="selected_zl" v-on:click="getData('zl',selected_zl)">
    <option value="">重量</option>
    <option value="0.3-5.0">0.3-5.0</option>
    <option value="0.3-0.39">0.3-0.39</option>
    <option value="0.4-0.49">0.4-0.49</option>
    <option value="0.5-0.59">0.5-0.59</option>
    <option value="0.6-0.69">0.6-0.69</option>
    <option value="0.7-0.79">0.7-0.79</option>
    <option value="0.8-0.89">0.8-0.89</option>
    <option value="0.9-0.99">0.9-0.99</option>
    <option value="1.0-1.49">1.0-1.49</option>
    <option value="1.5-1.99">1.5-1.99</option>
    <option value="2.0-2.99">2.0-2.99</option>
    <option value="3-3.99">3-3.99</option>
    <option value="4-4.99">4-4.99</option>
    <option value="5-9.99">5-9.99</option>
    <option value="10ct以上">10ct以上</option>
</select>
</td>

<td width="6%">
<select id="yc" style="color:blue;border:0" v-model="selected_yc" v-on:click="getData('yc',selected_yc)">
        <option value ="">颜色</option>
  <option value ="D">D</option>
  <option value="E">E</option>
  <option value="F">F</option>
    <option value ="G">G</option>
  <option value="H">H</option>
  <option value="I">I</option>
  <option value="J">J</option>

  <option value="K">K</option>
    <option value ="L">L</option>
  <option value="M">M</option>
  <option value="N">N</option>
  <option value="O">O</option>
  

</select>
</td>

<td width="5%">
<select id="jd" style="color:blue;border:0" v-model="selected_jd" v-on:click="getData('jd',selected_jd)">
        <option value ="">净度</option>
  <option value ="IF">IF</option>
  <option value="VVS1">VVS1</option>
  <option value="VVS2">VVS2</option>
    <option value ="VS1">VS1</option>
  <option value="VS2">VS2</option>
  <option value="SI1">SI1</option>
  <option value="SI2">SI2</option>
</select>
</td>
<td width="6%">金额</td><td>
<select id="qg" style="color:blue;border:0" v-model="selected_qg" v-on:click="getData('qg',selected_qg)">
        <option value ="">切工</option>
        <option value ="ID">ID</option>    
  <option value ="EX">EX</option>
  <option value="VG">VG</option>
  <option value="GD">GD</option>
</select>
</td>
<td>
  抛光
</td>
<td>
  对称
</td>
<td>
<select id="yg" style="color:blue;border:0" v-model="selected_yg" v-on:click="getData('yg',selected_yg)">
        <option value ="">荧光</option>
  <option value ="N">N</option>
  <option value="F">F</option>
  <option value="M">M</option>
  <option value="S">S</option>
  <option value="VS">VS</option>
</select>
</td>
<td width="8%">尺寸</td><td width="3%">台面</td><td width="3%">亭深</td>
<td width="3%">色调</td>
<td>改色</td>

<td width="4%">
<select id="zt" style="color:blue;border:0" v-model="selected_zt" v-on:click="getData('zt',selected_zt)">
        <option value ="">状态</option>
        <option value ="在售">在售</option>
        <option value="保留">保留</option>
        <option value="预售">预售</option>
</select>
</td>

<td width="4%">
<select id="pylx" style="color:blue;border:0" v-model="selected_pylx" v-on:click="getData('pylx',selected_pylx)">
        <option value ="">类型</option>
        <option value ="CVD">CVD</option>
        <option value="HPHT">HPHT</option>
</select>
</td>

<td width="3%">证书</td>
<td width="3%">图</td>
<td v-if="userinfo.level==2" width="4%">---</td>
</tr>

<tr onmouseover="this.style.background='orange'" onmouseout="this.style.background=''" v-for="diamond in diamonds" :class="{on:diamond.id%2==0,off:diamond.id%2!=0}">
<td>{{diamond.jdzs}}</td>

<td>{{diamond.hao}}</td>
<td>{{diamond.zsh}}</td>
<td>{{diamond.xz}}</td>
<td>{{diamond.zl}}</td>
<td>{{diamond.yc}}</td>
<td>{{diamond.jd}}</td>
<td  width="6%" v-html="diamond.zje"></td>
<td>{{diamond.qg}}</td>
<td>{{diamond.pg}}</td>
<td>{{diamond.dc}}</td>
<td>{{diamond.yg}}</td>
<td><a :href="'#'" :title="diamond.cc" >{{ diamond.cc }}</a></td>
<td>{{format(diamond.tm)}}</td>
<td>{{format(diamond.sd)}}</td>
<td>{{diamond.sediao}}</td>
<td>{{diamond.gs}}</td>
<td>{{diamond.zt}}</td>
<td>{{diamond.pylx}}</td>
<td>
<a v-bind:href="'https://www.igi.org/zh/verify-your-report/?r=' + diamond.zsh" onclick="alert(diamond.zsh)" target='_blank'>证书</a>
</td>
<td>
<a v-bind:href="'http://file.giazh.com/' + diamond.zsh + '.jpg'" onclick="alert(diamond.zsh)" target='_blank'>图</a>
</td>
<td v-if="userinfo.level==2">
<div v-if="(diamond.cartszsh==null||(diamond.cartszsh!=null&&diamond.username!=username))&&diamond.is_delete==0">
<button style="white-space:nowrap;padding:0px 2px" v-on:click="addCart(diamond,diamond.id)" class="btn btn-default">购物车</button>
</div>
<div v-if="diamond.is_delete==1">已被订购</div>
</td>
</tr>
</table>


</div>



<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                            <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>
                    </div>
                </div>
            </div>



  </div>
</template>

<script>
 // 引入公共的bug，来做为中间传达的工具
  import Bus from './bus.js'

export default {
  name: 'Vi',
  data(){
  return {
  title:"在线浏览",
  token:localStorage.authorization,
  url:'',
  cart_url:'https://www.giazh.com/auth/cart/add',
  hold_url:'https://www.giazh.com/auth/hold/add',
  hl:'',
  tips:'',
  cartnum:0,
  username:'',
  userinfo:{'level':0,'download':0},
  selected_xz: '',
   selected_zl: '' ,
  selected_yc: '' ,
  selected_jd: '' ,
  selected_qg: '' ,
  selected_pg: '' ,
  selected_dc: '' ,
  selected_yg: '' ,
  selected_zt: '' ,
  selected_pylx: '' ,
  loading:false,
  zsh:'',
  hao:'',
  bod:[],
  da:[],
  page:true,
  diamonds:[]
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
    elementByValue: function () {
        Bus.$emit('val', this.cartnum)
      },
      elementByValue2: function () {
	Bus.$emit('val2', this.user_info)
      },
     addCart: function(diamond,id) {

	      this.$http.post(this.cart_url,{goods_id:id},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.getCartNum();
	    diamond.cartszsh=1;
	    diamond.username=this.username;
	    alert('添加购物车成功,请到购物车提交订单');
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });

            },
            addHold: function(diamond,zsh) {

        this.$http.post(this.hold_url,{zsh:zsh},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.getCartNum();
      diamond.cartszsh=1;
      diamond.username=this.username;
      alert('添加留货成功,将保留一天');
      }).catch(err => {
        console.log(err);
        //localStorage.clear();
        //alert('已退出');
        //window.location.reload(true);
            });

            },
     getData: function (type,value) {
      this.page = true;
     if(this.token){
		 this.url="https://www.giazh.com/auth/mitation";
         this.da = {xz:this.selected_xz,pylx:this.selected_pylx,zl:this.selected_zl,yc:this.selected_yc,jd:this.selected_jd,qg:this.selected_qg,pg:this.selected_pg,dc:this.selected_dc,yg:this.selected_yg,zt:this.selected_zt};
		 }else{
		  this.url="https://www.giazh.com/api/mitation";
         this.da = {xz:this.selected_xz,pylx:this.selected_pylx,zl:this.selected_zl,yc:this.selected_yc,jd:this.selected_jd,qg:this.selected_qg,pg:this.selected_pg,dc:this.selected_dc,yg:this.selected_yg,zt:this.selected_zt};
		 }
		 console.log('加载中');
		   this.loading=true; 
		
          this.$http.post(this.url,this.da,{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	     this.bod=data.body;
           this.diamonds=data.body.data;
	     console.log('加载完成');
	     this.loading=false;
	   // this.hl=this.diamonds[0]['hl'];
	   this.tips=this.diamonds[0]['tips'];
     console.log(this.tips);
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });
    }
    ,
    search: function (url='') {
    this.page = true;
    console.log('serach.this.page', this.page);
   /* var type ='';
   
    var data ='';
     if(this.zsh.trim()){
        type ='zsh';
        data = this.zsh;
     }else if(this.hao.trim()){
        type ='hao';
        data = this.hao;
     }*/
     if(this.token){
         if(!url){
         this.url="https://www.giazh.com/auth/mitation";
          this.da = {zl:this.selected_zl,yc:this.selected_yc,jd:this.selected_jd,qg:this.selected_qg,pg:this.selected_pg,dc:this.selected_dc,yg:this.selected_yg,zsh:this.zsh.trim(),hao:this.hao.trim(),zt:this.selected_zt};
         }
     } else{
          if(!url){
          this.url="https://www.giazh.com/api/mitation";
           this.da = {zl:this.selected_zl,yc:this.selected_yc,jd:this.selected_jd,qg:this.selected_qg,pg:this.selected_pg,dc:this.selected_dc,yg:this.selected_yg,zsh:this.zsh,hao:this.hao,zt:this.selected_zt};
          }
     }
     console.log('加载中');
       this.loading=true; 
          var that = this;
          this.$http.post(this.url,this.da,{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
          that.loading=false;
          if(data.body == 'this user is not allowed'){
                alert('当前用户无权限');
                return false;
              }
          if(data.body.last_page == data.body.current_page){
               this.page = false;
              }

          this.bod=data.body;
           //this.diamonds=data.body.data;
            if(this.zsh||this.hao){
            this.diamonds = data.body.data;
            } else{
               if(data.body.last_page >= data.body.current_page){
               
                    if(data.body.last_page==1&&data.body.current_page==1){
                    // this.diamonds = data.body.data;
                     this.page = false;
                    } else{
                     this.diamonds = this.diamonds.concat( data.body.data );
                   }
                    
                 
                  
               }
            }
            this.zsh ='';
            this.hao = '';
            
           
      console.log('2222',data);
       console.log('ssssss',this.diamonds);
      }).catch(err => {
        console.log(err);
            });
    },
     getCartNum: function () {
          this.$http.post('https://www.giazh.com/auth/cart/cartnum',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.cartnum=data.body;
	    this.elementByValue();
	   
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });
    },
     reset: function () {
        this.zsh='';
        this.hao='';
         if(this.token){
         this.username=localStorage.username;
         this.url="https://www.giazh.com/auth/mitation";
         this.getUserInfo();
         
         
         }else{
          this.url="https://www.giazh.com//api/mitation";
         }
        this.getData();
     }
    ,

     onScroll () {
   let scrollTop = document.documentElement.scrollTop;
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
   if (scrollTop + windowHeight + 100 >= scrollHeight ) {
   console.log('this.page',this.page);
            if(this.bod.next_page_url!=this.url && this.page){
              this.url = this.bod.next_page_url;
              this.search(this.url);
            }            
   }
  },

     getUserInfo: function () {
          this.$http.post('https://www.giazh.com/auth/user/userinfo',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.userinfo=data.body;
	    this.elementByValue2();
	   
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });
    }
    ,
    rate: function () {
          this.$http.post('https://www.giazh.com/api/mrate',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.hl=data.body;
     
      }).catch(err => {

            });
    }
  },
  components:{
  },
  created(){
	       if(this.token){
	       this.username=localStorage.username;
		 this.url="https://www.giazh.com/auth/mitation";
		 this.getUserInfo();
		 
		 
		 }else{
		  this.url="https://www.giazh.com/api/mitation";
		 }
		    this.getData();

		  window.addEventListener('scroll', this.onScroll); 

      this.rate();  

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}


.ov {overflow:hidden; white-space:nowrap; text-overflow:ellipsis;width:3% }
/*.ov:hover { width:150px; }
.ov2 {overflow:hidden; white-space:nowrap; text-overflow:ellipsis;width:2%; }
.ov2:hover { width:150px; }*/




</style>


// WEBPACK FOOTER //
// src/components/Mitation.vue